import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__16';
import {SVGIcon} from '@homeaway/react-svg';

export class CancelTripModalCategory extends Component {
    static propTypes = {
        category: PropTypes.shape({
            descriptionText: PropTypes.string,
            text: PropTypes.string,
        }),
        onClick: PropTypes.func,
    };

    static defaultProps = {
        category: {},
        onClick: () => {},
    };

    onClick = (event) => {
        const {category, onClick} = this.props;

        event.preventDefault();
        onClick(category);
    };

    render() {
        const {category} = this.props;

        return (
            <div className="panel--cancel-trip">
                <a
                    className={'panel--cancel-trip_link text-default'}
                    href={''}
                    onClick={this.onClick}
                >
                    <div>
                        <h4>{category.text}</h4>
                        <div className="small text-400">
                            {category.descriptionText}
                        </div>
                    </div>
                    <span className="text-brand">
                        <SVGIcon markup={CHEVRON_RIGHT__16} useFill />
                    </span>
                </a>
            </div>
        );
    }
}
